var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIpWhiteList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.75C14.5 9.955 12.1375 13.4875 10.21 16C8.875 17.74 7.75 19 7.75 19C7.75 19 6.625 17.74 5.29 16C3.3625 13.4875 1 9.955 1 7.75C1 4.0225 4.0225 1 7.75 1C11.4775 1 14.5 4.0225 14.5 7.75Z",
    stroke: "#FF9900",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22H1L2.5 16H5.29C6.625 17.74 7.75 19 7.75 19C7.75 19 8.875 17.74 10.21 16H13L14.5 22Z",
    stroke: "#FF9900",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67188 9.29785V4.78613C4.67188 4.55176 4.72526 4.37598 4.83203 4.25879C4.9388 4.1416 5.07682 4.08301 5.24609 4.08301C5.42057 4.08301 5.5612 4.1416 5.66797 4.25879C5.77734 4.37337 5.83203 4.54915 5.83203 4.78613V9.29785C5.83203 9.53483 5.77734 9.71191 5.66797 9.8291C5.5612 9.94629 5.42057 10.0049 5.24609 10.0049C5.07943 10.0049 4.94141 9.94629 4.83203 9.8291C4.72526 9.70931 4.67188 9.53223 4.67188 9.29785ZM9.35547 7.67676H8.29297V9.29785C8.29297 9.52962 8.23828 9.7054 8.12891 9.8252C8.01953 9.94499 7.88151 10.0049 7.71484 10.0049C7.54036 10.0049 7.39974 9.94629 7.29297 9.8291C7.1862 9.70931 7.13281 9.53483 7.13281 9.30566V4.8916C7.13281 4.63639 7.19141 4.4541 7.30859 4.34473C7.42578 4.23535 7.61198 4.18066 7.86719 4.18066H9.35547C9.79557 4.18066 10.1341 4.21452 10.3711 4.28223C10.6055 4.34733 10.8073 4.4554 10.9766 4.60645C11.1484 4.75749 11.2786 4.94238 11.3672 5.16113C11.4557 5.37988 11.5 5.62598 11.5 5.89941C11.5 6.48275 11.3203 6.92546 10.9609 7.22754C10.6016 7.52702 10.0664 7.67676 9.35547 7.67676ZM9.07422 5.05176H8.29297V6.80176H9.07422C9.34766 6.80176 9.57552 6.77311 9.75781 6.71582C9.94271 6.65853 10.0833 6.56478 10.1797 6.43457C10.276 6.30436 10.3242 6.13379 10.3242 5.92285C10.3242 5.67025 10.25 5.46452 10.1016 5.30566C9.9349 5.13639 9.59245 5.05176 9.07422 5.05176Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpWhiteList);
export default __webpack_public_path__ + "static/media/IPWhiteList.cfe87260c64343ffa1796b21e3939e96.svg";
export { ForwardRef as ReactComponent };